// src/App.js
import './App.css';
import LandingPage from './components/LandingPage';
import AdminPanel from './components/AdminPanel'; // Import AdminPanel if needed
import Disclaimer from './components/Disclaimer'; // Import the Disclaimer component
import PrivacyPolicy from './components/policies/PrivacyPolicy';
import TermsOfService from './components/policies/TermsOfService';
import AboutUs from './components/policies/AboutUs';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/about-us" element={<AboutUs />} />
          {/* <Route path="/admin" element={<AdminPanel />} /> */}
        </Routes>
      </Router>
      <Disclaimer /> {/* Add the disclaimer component */}
    </div>
  );
}

export default App;
